import { render, staticRenderFns } from "./AddressListView.vue?vue&type=template&id=23968825&scoped=true"
import script from "./AddressListView.vue?vue&type=script&lang=js"
export * from "./AddressListView.vue?vue&type=script&lang=js"
import style0 from "./AddressListView.vue?vue&type=style&index=0&id=23968825&prod&lang=less&scoped=true"
import style1 from "./AddressListView.vue?vue&type=style&index=1&id=23968825&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_c6nu2kfme4k2fztecbunkha7um/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23968825",
  null
  
)

export default component.exports